import ButtonVariants from "@core-components/button/ButtonVariants";
import GradientBorder from "@core-components/gradient-border/GradientBorder";
import useAppTranslation from "@hooks/language/useAppTranslation";

interface IUseMyCoinsButtonProps {
  onClick: () => void;
  className?: string;
}

const UseMyCoinsButton: React.FC<IUseMyCoinsButtonProps> = ({
  onClick,
  className,
}) => {
  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <GradientBorder className="gradient-border-white hover-scale rounded-md">
      <ButtonVariants.Gradient
        onClick={onClick}
        className={`gradient-blue-light-purple rounded-md ${className}`}
        label={t("useMyCoinsButton.label")}
      />
    </GradientBorder>
  );
};

export default UseMyCoinsButton;
